import script from "./newReportStatisticalAnalysis.component.vue?vue&type=script&lang=ts&setup=true"
export * from "./newReportStatisticalAnalysis.component.vue?vue&type=script&lang=ts&setup=true"

import "./newReportStatisticalAnalysis.component.vue?vue&type=style&index=0&id=70a5a7da&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/WEAS/WEAS_CI/WEAS_FRONT/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70a5a7da"]])

export default __exports__